import React from "react";
import "./App.css";

const services = [
  {
    icon: "▤",
    title: "ثبت و ارسال اظهارنامه",
    text: "ثبت و ارسال اظهارنامه مالیاتی اشخاص حقیقی و استفاده از ظرفیت تبصره ماده ۱۰۰.",
  },
  {
    icon: "▣",
    title: "بررسی پرونده و مستندات",
    text: "بررسی اطلاعات و مدارک موردنیاز پیش از نهایی‌سازی درخواست.",
  },
  {
    icon: "⚖",
    title: "مشاوره تخصصی مالیاتی",
    text: "ارائه راهنمایی تخصصی در زمینه امور مالیاتی اشخاص حقیقی.",
  },
];

const advantages = [
  "انجام سریع و دقیق مراحل",
  "پشتیبانی و پیگیری تا حصول نتیجه نهایی",
  "انجام کلیه امور به‌صورت غیرحضوری",
];

const steps = [
  ["۰۱", "ثبت درخواست", "اطلاعات اولیه خود را در پلتفرم ثبت کنید."],
  ["۰۲", "بررسی پرونده", "پرونده و مستندات شما بررسی می‌شود."],
  ["۰۳", "محاسبه و تأیید نهایی", "نتیجه برای تأیید نهایی در اختیار شما قرار می‌گیرد."],
  ["۰۴", "ارسال اظهارنامه", "اظهارنامه ارسال و کد رهگیری دریافت می‌شود."],
];

function SectionHeading({ label, title, description }) {
  return (
    <div className="section-heading">
      {label && <span className="section-label">{label}</span>}
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
  );
}

export default function App() {
  return (
    <main className="landing-page" dir="rtl">
      <header className="hero" id="home">
        <div className="container">
          <nav className="navbar">
            <a className="brand" href="#home" aria-label="خدمات نوین و هوشمند مالی">
              <span className="brand-mark">خ</span>
              <span>خدمات نوین و هوشمند مالی</span>
            </a>
            <a className="button button-outline-light nav-cta" href="#contact">
              ارتباط با کارشناسان
            </a>
          </nav>

          <div className="hero-grid">
            <div className="hero-content">
              <span className="hero-badge">ویژه صاحبان مشاغل و اشخاص حقیقی</span>
              <h1>
                ارسال اظهارنامه مالیاتی
                <strong>و تبصره ماده ۱۰۰</strong>
              </h1>
              <p className="hero-description">
                خدمات تخصصی ثبت، بررسی و ارسال اظهارنامه مالیاتی اشخاص حقیقی؛
                سریع، مطمئن و کاملاً غیرحضوری.
              </p>
              <div className="hero-actions">
                <a className="button button-secondary" href="https://panel.accnfk.com">
                  ثبت‌نام در پلتفرم
                  <span aria-hidden="true">←</span>
                </a>
                <a className="button button-outline-light" href="#services">
                  مشاهده خدمات
                </a>
              </div>
              <div className="deadline">
                <span className="deadline-dot" />
                فرصت استفاده از خدمات: فقط تا ۳۰ آبان
              </div>
            </div>

            <div className="hero-card-wrap">
              <div className="hero-orbit orbit-one" />
              <div className="hero-orbit orbit-two" />
              <div className="hero-card">
                <div className="hero-card-icon">٪</div>
                <span className="hero-card-kicker">خدمات مالیاتی آنلاین</span>
                <h2>مسیر ساده‌تر امور مالیاتی شما</h2>
                <p>
                  بدون نیاز به مراجعه حضوری، مراحل درخواست خود را از طریق پلتفرم
                  دنبال کنید.
                </p>
                <a href="https://panel.accnfk.com" className="button button-primary">
                  ورود به پلتفرم
                </a>
              </div>
            </div>
          </div>
          <div className="hero-bottom-line" />
        </div>
      </header>

      <section className="partners-section">
        <div className="container">
          <div className="partner-grid">
            <div className="partner-card">
              <span className="partner-icon">✦</span>
              <strong>شرکت فن صاد</strong>
              <small>مجری طرح</small>
            </div>
            <div className="partner-card">
              <span className="partner-icon">⌂</span>
              <strong>مرکز تحقیقات راهبری‌های نوین در مدیریت</strong>
              <small>دانشکده مدیریت و اقتصاد دانشگاه آزاد اسلامی</small>
            </div>
            <div className="partner-card">
              <span className="partner-icon">◈</span>
              <strong>گروه مالی نیک‌اندیشان</strong>
              <small>همکار طرح</small>
            </div>
          </div>
          <p className="partners-description">
            این طرح توسط شرکت فن صاد، وابسته به دانشگاه علوم و تحقیقات، با همکاری
            مرکز تحقیقات راهبری‌های نوین در مدیریت و گروه مالی نیک‌اندیشان ارائه
            می‌شود.
          </p>
        </div>
      </section>

      <section className="section container" id="services">
        <SectionHeading
          label="خدمات ما"
          title="همراه شما در انجام امور مالیاتی"
          description="از ثبت درخواست تا ارسال نهایی اظهارنامه، مراحل را با پشتیبانی تخصصی دنبال کنید."
        />
        <div className="service-grid">
          {services.map((service, index) => (
            <article className="service-card" key={service.title}>
              <div className={`service-icon service-icon-${index + 1}`}>
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
              <span className="card-arrow">←</span>
            </article>
          ))}
        </div>
      </section>

      <section className="benefits-section">
        <div className="container section">
          <SectionHeading
            label="چرا فن صاد؟"
            title="مزایای استفاده از خدمات"
            description="تجربه‌ای ساده‌تر، دقیق‌تر و قابل پیگیری برای انجام امور مالیاتی."
          />
          <div className="benefit-grid">
            {advantages.map((item, index) => (
              <div className="benefit-item" key={item}>
                <span className="benefit-check">{index + 1}</span>
                <strong>{item}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section container process-section">
        <SectionHeading
          label="فرایند انجام کار"
          title="چهار گام تا ارسال اظهارنامه"
          description="فرایند به‌صورت غیرحضوری و مرحله‌به‌مرحله انجام می‌شود."
        />
        <div className="steps-grid">
          {steps.map(([number, title, description]) => (
            <article className="step-card" key={number}>
              <span className="step-number">{number}</span>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="container final-cta">
        <div className="cta-decoration">٪</div>
        <div className="cta-content">
          <span>تمامی مراحل به‌صورت غیرحضوری</span>
          <h2>همین حالا درخواست خود را ثبت کنید</h2>
          <p>برای شروع فرایند ثبت و ارسال اظهارنامه مالیاتی به پلتفرم مراجعه کنید.</p>
          <a className="button button-secondary" href="https://panel.accnfk.com">
            ثبت‌نام در پلتفرم <span aria-hidden="true">←</span>
          </a>
        </div>
      </section>

      <footer className="footer" id="contact">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-about">
              <a className="brand footer-brand" href="#home">
                <span className="brand-mark">خ</span>
                <span>خدمات نوین و هوشمند مالی</span>
              </a>
              <p>
                مجری خدمات ثبت و ارسال اظهارنامه اشخاص حقیقی و تبصره ماده ۱۰۰.
              </p>
              <div className="footer-address">
                <span>⌖</span>
                <p>
                  انتهای ستاری، دانشگاه آزاد اسلامی، واحد علوم و تحقیقات،
                  کتابخانه مرکزی، طبقه همکف و پنجم
                </p>
              </div>
            </div>

            <div className="footer-column">
              <h3>راه‌های ارتباطی</h3>
              <a href="tel:02128421776">☎ ۰۲۱-۲۸۴۲۱۷۷۶</a>
              <a href="mailto:fansad.company@gmail.com">
                ✉ fansad.company@gmail.com
              </a>
              <span>WhatsApp: @fansad_company</span>
            </div>

            <div className="footer-column">
              <h3>شبکه‌های اجتماعی</h3>
              <a href="https://t.me/fansad_company">Telegram</a>
              <a href="https://ble.ir/fansad_company">Bale</a>
              <a href="https://instagram.com/fansad_company">Instagram</a>
              <a href="https://linkedin.com/company/fansadco">LinkedIn</a>
            </div>
          </div>
          <a className="footer-bottom" href="https://ibinsina.com">
            <span>طراحی و توسعه : علم و فناوری و خدمات مدیریت ابن سینا</span>
            <span></span>
          </a>
        </div>
      </footer>
    </main>
  );
}